module.exports = __webpack_public_path__ + "static/media/about.cf0a1fca.png";